import { useForm, router } from '@inertiajs/react';
import { useState } from 'react';

export default function Order({ order, statuses }) {
  const { put } = useForm();
  const [status, setStatus] = useState(order.status);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);

    router.put(
      `/dashboard/orders/${order.id}`,
      {
        order: { status: newStatus },
      },
      {
        preserveScroll: true,
        preserveState: true,
      }
    );
  }

  return (
    <div
      className={`bg-white shadow-lg rounded-2xl p-6 mb-6 w-full max-w-2xl mx-auto border border-gray-200 transition hover:shadow-xl ${
        status === 'cancelled' ? 'cursor-not-allowed opacity-60' : ''
      }`}
    >
      <dl className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div>
          <dt className='block font-medium text-gray-700'>Customer name:</dt>
          <dd className='text-gray-900'>{order.customer_name}</dd>
        </div>
        <div>
          <dt className='block font-medium text-gray-700'>Customer phone:</dt>
          <dd className='text-gray-900'>{order.customer_phone}</dd>
        </div>
        <div>
          <dt className='block font-medium text-gray-700'>Address:</dt>
          <dd className='text-gray-900'>{order.customer_address}</dd>
        </div>
        <div>
          <dt className='block font-medium text-gray-700'>Total amount:</dt>
          <dd className='text-gray-900 font-semibold'>₵{order.total_amount}</dd>
        </div>
        <div className='flex gap-3'>
          <dt className='font-medium text-gray-700'>Status:</dt>
          <dd
            className={`px-2 py-0.5 rounded-full text-sm font-medium ${
              (order.status || status) === 'pending'
                ? 'bg-gray-100 text-gray-700'
                : (order.status || status) === 'processing'
                ? 'bg-yellow-100 text-yellow-700'
                : (order.status || status) === 'shipped'
                ? 'bg-blue-100 text-blue-700'
                : (order.status || status) === 'delivered'
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {order?.status || status}
          </dd>
        </div>
      </dl>

      {order.notes && (
        <dl className='mt-4 text-sm text-gray-600'>
          <dt className='font-medium text-gray-700'>Notes:</dt>{' '}
          <dd>{order.notes}</dd>
        </dl>
      )}
      <div className='mt-3'>
        <fieldset
          className='flex flex-wrap gap-3'
          disabled={status === 'cancelled'}
        >
          {statuses?.map((stat) => (
            <label
              key={stat}
              className={`flex items-center space-x-2 text-sm ${
                status === 'cancelled'
                  ? 'cursor-not-allowed opacity-60'
                  : 'cursor-pointer'
              }`}
            >
              <input
                type='radio'
                name='status'
                value={stat}
                checked={status === stat}
                onChange={handleStatusChange}
                className={`h-4 w-4 text-yellow-tertiary ${
                  status === stat ? 'border-yellow-tertiary' : 'border-gray-400'
                }  focus:ring-yellow-tertiary`}
                disabled={status === 'cancelled'}
              />
              <span
                className={`capitalize ${
                  status === stat
                    ? 'font-semibold text-yellow-tertiary'
                    : 'text-gray-600'
                }`}
              >
                {stat}
              </span>
            </label>
          ))}
        </fieldset>
      </div>

      <div className='mt-6 flex justify-end'>
        <a
          href={`/dashboard/orders/${order.id}`}
          className='rounded-lg bg-yellow-tertiary text-white px-4 py-2 text-sm font-medium hover:bg-yellow-primary transition'
        >
          View items
        </a>
      </div>
    </div>
  );
}
